import React, { useEffect, useState } from 'react';
import { addNewsPostAction, deleteNewsPostAction, getNewsPostAction } from '../../../../module/action/NewsPosts';
import { useDispatch, useSelector } from 'react-redux';
import Spinner from '../../../../Constants/Spinner';
import EditPostModal from '../../components/EditPostModal';
import DeletePostModal from '../../../../Constants/deletePostModal';
import TicIcon from '../../../../Assets/Icons/TicIcon';
import LinesIcon from '../../../../Assets/Icons/LinesIcon';
import EditIcon from '../../../../Assets/Icons/EditIcon';
import DeleteIcon from '../../../../Assets/Icons/DeleteIcon';
import { toast } from 'react-toastify';

function NewPosts() {
  const dispatch = useDispatch();
  const [postText, setPostText] = useState('');
  const NewsPosts = useSelector(e => e.NewsPosts.NewsPosts);
  const addNewsPostLoader = useSelector(e => e.NewsPosts.addNewsPostLoader);
  const [editPost, setEditPost] = useState(false);
  const [deletePost, setDeletePost] = useState(false);
  const clearState = () => {
    setPostText('');
  };
  useEffect(() => {
    dispatch(getNewsPostAction(clearState));
  }, []);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const showEditModal = a => {
    setIsEditModalOpen(true);
    setEditPost(a);
  };
  const handleEditOk = () => {
    setIsEditModalOpen(false);
    setEditPost(false);
  };
  const handleEditCancel = () => {
    setIsEditModalOpen(false);
    setEditPost(false);
  };

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const showDeleteModal = a => {
    setIsDeleteModalOpen(true);
    setDeletePost(a);
  };
  const handleDeleteOk = () => {
    setIsDeleteModalOpen(false);
    setDeletePost(false);
  };
  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
    setDeletePost(false);
  };

  const deleteNewsPostLoader = useSelector(e => e.NewsPosts.deleteNewsPostLoader);
  const deletePostFn = () => {
    dispatch(deleteNewsPostAction(deletePost, handleDeleteOk));
  };
  const onSubmit = () => {
    if (postText) {
      dispatch(
        addNewsPostAction({
          title_name: postText,
        })
      );
      setPostText('');
    } else {
      toast.error('please add news post text');
    }
  };
  return (
    <div className="NewPosts my-12 px-8 innerDashboard">
      {/* <Logo /> */}
      <div className="header  justify-between flex">
        <div className="flex align-middle items-center">
          <h2 className="text-[32px] font-extrabold ">News Posts</h2>
        </div>
      </div>
      <div className=" px-8 bg-[#eef2f0] rounded-s-lg py-6 w-full mt-14">
        <p className="text-sm text-black font-semibold mb-4">Post Title</p>
        <div className="flex items-center justify-between w-full">
          <input
            value={postText}
            className="w-[calc(100%-133px)] px-6 rounded-lg outline-0 h-[48px] text-sm"
            placeholder="Write post here"
            onChange={ev => {
              setPostText(ev.target.value);
            }}
          />
          <button
            disabled={addNewsPostLoader}
            className="relative rounded-xl w-[103px] h-[48px]  text-white bg-[#2a9134] py-3.5 flex items-center justify-center"
            onClick={onSubmit}>
            {addNewsPostLoader ? <Spinner /> : null}
            <TicIcon className={addNewsPostLoader ? `opacity-0 ` : ''} stroke="#fff" />
          </button>
        </div>
      </div>
      <p className="text-sm text-black font-semibold mb-4 mt-10">Posts</p>
      <div className="table  bg-[#eef2f0] rounded-s-lg  w-full ">
        {NewsPosts.map((a, i) => (
          <div className="table-row" key={i}>
            <div className="table-cell py-4 pl-4 align-middle w-[50px] border-b-[8px] border-white">
              <LinesIcon />
            </div>
            <div className="table-cell py-4   align-middle  border-b-[8px] border-white">
              <p dir="rtl" className="mr-[3%] urduText text-left font-bold">
                {a.title_name}
              </p>
            </div>
            <div className="table-cell py-4 pr-2  align-middle  border-b-[8px] border-white">
              <div className="flex items-center justify-end">
                <button
                  onClick={() => showEditModal(a)}
                  className="mr-2 flex items-center justify-center w-[32px] h-[32px] rounded-full bg-black">
                  <EditIcon width={26} height={24} fill="#fff" />
                </button>
                <button
                  onClick={() => showDeleteModal(a)}
                  className="flex items-center justify-center w-[32px] h-[32px] rounded-full bg-[#ca3030]">
                  <DeleteIcon svgProps={{ className: 'w-[20px] h-[20px]' }} pathProp={{ fill: '#fff' }} />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
      <EditPostModal
        isEditModalOpen={isEditModalOpen}
        setIsEditModalOpen={setIsEditModalOpen}
        showEditModal={showEditModal}
        handleEditOk={handleEditOk}
        handleEditCancel={handleEditCancel}
        editPost={editPost}
        setEditPost={setEditPost}
      />
      <DeletePostModal
        isDeleteModalOpen={isDeleteModalOpen}
        setIsDeleteModalOpen={setIsDeleteModalOpen}
        showDeleteModal={showDeleteModal}
        handleDeleteOk={handleDeleteOk}
        handleDeleteCancel={handleDeleteCancel}
        deletePost={deletePost}
        setDeletePost={setDeletePost}
        loader={deleteNewsPostLoader}
        deleteFun={deletePostFn}
        modalText="Do you want to delete this news post?"
      />
    </div>
  );
}

export default NewPosts;
